// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2187d052","239":"0484b6d4","453":"75d02731","455":"61e6e02c"}[chunkId] + ".chunk.js";
};